import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import { Course } from '../Models/course.model';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { timeout } from 'rxjs/operator/timeout';

@Component({
  selector: 'app-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.css']
})
export class ShareDialogComponent implements OnInit {

  course: Course;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snotifyService: SnotifyService,
  ) { }

  ngOnInit() {
    this.course = this.data.course;
  }

  onInputChange(copyTextInputRef){
    copyTextInputRef.value = "https://dataorbit.ca/course/" + this.course.id;
  }

  onCopyToClipBoard(copyTextInputRef){
    copyTextInputRef.select();
    document.execCommand('copy');
    copyTextInputRef.setSelectionRange(0, 0);
    this.snotifyService.info(`Copied url to clip board`, {position:SnotifyPosition.rightTop});
  }

}



// WEBPACK FOOTER //
// ./src/app/share-dialog/share-dialog.component.ts